<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-flex xs4 sm4 md4 lg4 >

        <v-data-table
                dense
                :headers="clinicHeaders"
                id="clinicTable"
                :items="clinicData"
                :loading="loading"
                :loading-text="loadingText"
                hide-default-footer
                hide-default-header
                item-key="chart_no"
                disable-pagination
                class="elevation-1">

            <template v-slot:header="{ props }">
                <tr class="px-0 text-left">
                    <th style="font-weight: bold;background: #C7E3FD;" :class="[ 'px-0','text-center','tableHeaderRight','tableHeaderBottom','tableHeader']">
                        <span v-html="clinicHeaders[0].text"></span>
                    </th>
                </tr>
            </template>



            <template slot="item" slot-scope="props" style="border: 1px solid black">
                <tr>
                    <td  v-show="dateIndex==0" @click="linkUrl(props.item.viewItemUrl1)"  style="min-height: 80px" :class="['px-1 text-center tableHeaderRight linkName']"  >
                        <div  v-if="props.item.viewItemName1!==''"  :class="[props.item.viewItemName1!==''?'tdOutline':'tdNoOutline',isLink(props.item.viewItemUrl1)?'tdClick':'noLink']">
                            <div v-show="props.item.viewItemName1!==''" class="clinicName iconSmallFont">{{props.item.clinicName}}</div>
                            <div class="iconSmallFont">{{props.item.viewItemExtName1}} </div>
                            <div class="divName">
                                <!--額滿 #--><img v-show="props.item.viewItemMarkFlag1!==''&&props.item.viewItemMarkFlag1.indexOf('#')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/full.png">
                                <!--不允許網路掛號 *--><img v-show="props.item.viewItemMarkFlag1!==''&&props.item.viewItemMarkFlag1.indexOf('*')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/noReg.png">
                                <!--代診醫師 R --><img v-show="props.item.viewItemMarkFlag1!==''&&props.item.viewItemMarkFlag1.indexOf('R')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/replaceDoc.png">
                                <!--性平標記 六色旗 S --><img v-show="props.item.viewItemMarkFlag1!==''&&props.item.viewItemMarkFlag1.indexOf('S')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/sixColorFlag.png">
                                <span :class="[props.item.viewItemMarkFlag1!==''?'iconSmallFont':'']">{{props.item.viewItemName1}}</span>
                            </div>
                        </div>

                        <div v-else  :class="[props.item.viewItemMarkFlag1!==''?'iconSmallFont':'','tdNoOutline']">
                            <div class="iconSmallFont" style="color: transparent">empty</div>
                            <div class="iconSmallFont" style="color: transparent">empty</div>
                            <div  style="color: transparent">empty</div>
                        </div>

                        <!--<div v-if="props.item.viewItemName1!==''" :class="[props.item.viewItemName1!==''?'tdOutline':'tdNoOutline']" v-html="addLink(props.item.viewItemName1,props.item.viewItemUrl1,props.item.viewItemExtName1,props.item.clinicName)"></div>-->
                    </td>
                    <td v-show="dateIndex==1" @click="linkUrl(props.item.viewItemUrl2)" style="min-height: 80px" :class="['px-1 text-center tableHeaderRight linkName']"  >
                        <!--<div v-if="props.item.viewItemName2!==''" :class="[props.item.viewItemName2!==''?'tdOutline':'tdNoOutline']" v-html="addLink(props.item.viewItemName2,props.item.viewItemUrl2,props.item.viewItemExtName2,props.item.clinicName)"></div>-->
                        <div v-if="props.item.viewItemName2!==''"  :class="[props.item.viewItemName2!==''?'tdOutline':'tdNoOutline',isLink(props.item.viewItemUrl2)?'tdClick':'noLink']">
                            <div v-show="props.item.viewItemName2!==''" class="clinicName iconSmallFont">{{props.item.clinicName}}</div>
                            <div class="iconSmallFont">{{props.item.viewItemExtName2}}</div>
                            <div class="divName">
                                <!--額滿 #--><img v-show="props.item.viewItemMarkFlag2!==''&&props.item.viewItemMarkFlag2.indexOf('#')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/full.png">
                                <!--不允許網路掛號 *--><img v-show="props.item.viewItemMarkFlag2!==''&&props.item.viewItemMarkFlag2.indexOf('*')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/noReg.png">
                                <!--代診醫師 R --><img v-show="props.item.viewItemMarkFlag2!==''&&props.item.viewItemMarkFlag2.indexOf('R')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/replaceDoc.png">
                                <!--性平標記 六色旗 S --><img v-show="props.item.viewItemMarkFlag2!==''&&props.item.viewItemMarkFlag2.indexOf('S')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/sixColorFlag.png">
                                <span :class="[props.item.viewItemMarkFlag2!==''?'iconSmallFont':'']">{{props.item.viewItemName2}}</span>
                            </div>
                        </div>

                        <div v-else  :class="[props.item.viewItemMarkFlag2!==''?'iconSmallFont':'','tdNoOutline']">
                            <div class="iconSmallFont" style="color: transparent">empty</div>
                            <div class="iconSmallFont" style="color: transparent">empty</div>
                            <div style="color: transparent">empty</div>
                        </div>
                    </td>

                    <td v-show="dateIndex==2" @click="linkUrl(props.item.viewItemUrl3)" style="min-height: 80px" :class="['px-1 text-center tableHeaderRight linkName']"  >
                        <div v-if="props.item.viewItemName3!==''"  :class="[props.item.viewItemName3!==''?'tdOutline':'tdNoOutline',isLink(props.item.viewItemUrl3)?'tdClick':'noLink']">
                            <div v-show="props.item.viewItemName3!==''" class="clinicName iconSmallFont">{{props.item.clinicName}}</div>
                            <div class="iconSmallFont">{{props.item.viewItemExtName3}}</div>
                            <div class="divName">
                                <!--額滿 #--><img v-show="props.item.viewItemMarkFlag3!==''&&props.item.viewItemMarkFlag3.indexOf('#')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/full.png">
                                <!--不允許網路掛號 *--><img v-show="props.item.viewItemMarkFlag3!==''&&props.item.viewItemMarkFlag3.indexOf('*')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/noReg.png">
                                <!--代診醫師 R --><img v-show="props.item.viewItemMarkFlag3!==''&&props.item.viewItemMarkFlag3.indexOf('R')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/replaceDoc.png">
                                <!--性平標記 六色旗 S  --><img v-show="props.item.viewItemMarkFlag3!==''&&props.item.viewItemMarkFlag3.indexOf('S')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/sixColorFlag.png">
                                <span :class="[props.item.viewItemMarkFlag3!==''?'iconSmallFont':'']">{{props.item.viewItemName3}}</span>
                            </div>
                        </div>

                        <div v-else  :class="[props.item.viewItemMarkFlag3!==''?'iconSmallFont':'','tdNoOutline']">
                            <div class="iconSmallFont" style="color: transparent">empty</div>
                            <div class="iconSmallFont" style="color: transparent">empty</div>
                            <div style="color: transparent">empty</div>
                        </div>
                    </td>

                    <td v-show="dateIndex==3" @click="linkUrl(props.item.viewItemUrl4)" style="min-height: 80px" :class="['px-1 text-center tableHeaderRight linkName']"  >
                        <div v-if="props.item.viewItemName4!==''"  :class="[props.item.viewItemName4!==''?'tdOutline':'tdNoOutline',isLink(props.item.viewItemUrl4)?'tdClick':'noLink']">
                            <div v-show="props.item.viewItemName4!==''" class="clinicName iconSmallFont">{{props.item.clinicName}}</div>
                            <div class="iconSmallFont">{{props.item.viewItemExtName4}}</div>
                            <div class="divName">
                                <!--額滿 #--><img v-show="props.item.viewItemMarkFlag4!==''&&props.item.viewItemMarkFlag4.indexOf('#')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/full.png">
                                <!--不允許網路掛號 *--><img v-show="props.item.viewItemMarkFlag4!==''&&props.item.viewItemMarkFlag4.indexOf('*')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/noReg.png">
                                <!--代診醫師 R --><img v-show="props.item.viewItemMarkFlag4!==''&&props.item.viewItemMarkFlag4.indexOf('R')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/replaceDoc.png">
                                <!--性平標記 六色旗 S --><img v-show="props.item.viewItemMarkFlag4!==''&&props.item.viewItemMarkFlag4.indexOf('S')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/sixColorFlag.png">
                                <span :class="[props.item.viewItemMarkFlag4!==''?'iconSmallFont':'']">{{props.item.viewItemName4}}</span>
                            </div>
                        </div>

                        <div v-else  :class="[props.item.viewItemMarkFlag4!==''?'iconSmallFont':'','tdNoOutline']">
                            <div class="iconSmallFont" style="color: transparent">empty</div>
                            <div class="iconSmallFont" style="color: transparent">empty</div>
                            <div style="color: transparent">empty</div>
                        </div>
                    </td>

                    <td v-show="dateIndex==4" @click="linkUrl(props.item.viewItemUrl5)" style="min-height: 80px" :class="['px-1 text-center tableHeaderRight linkName']"  >
                        <div v-if="props.item.viewItemName5!==''"  :class="[props.item.viewItemName5!==''?'tdOutline':'tdNoOutline',isLink(props.item.viewItemUrl5)?'tdClick':'noLink']">
                            <div v-show="props.item.viewItemName5!==''" class="clinicName iconSmallFont">{{props.item.clinicName}}</div>
                            <div class="iconSmallFont">{{props.item.viewItemExtName5}}</div>
                            <div class="divName">
                                <!--額滿 #--><img v-show="props.item.viewItemMarkFlag5!==''&&props.item.viewItemMarkFlag5.indexOf('#')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/full.png">
                                <!--不允許網路掛號 *--><img v-show="props.item.viewItemMarkFlag5!==''&&props.item.viewItemMarkFlag5.indexOf('*')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/noReg.png">
                                <!--代診醫師 R --><img v-show="props.item.viewItemMarkFlag5!==''&&props.item.viewItemMarkFlag5.indexOf('R')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/replaceDoc.png">
                                <!--性平標記 六色旗 S --><img v-show="props.item.viewItemMarkFlag5!==''&&props.item.viewItemMarkFlag5.indexOf('S')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/sixColorFlag.png">
                                <span :class="[props.item.viewItemMarkFlag5!==''?'iconSmallFont':'']">{{props.item.viewItemName5}}</span>
                            </div>
                        </div>

                        <div v-else :class="[props.item.viewItemMarkFlag5!==''?'iconSmallFont':'','tdNoOutline']">
                            <div class="iconSmallFont" style="color: transparent">empty</div>
                            <div class="iconSmallFont" style="color: transparent">empty</div>
                            <div style="color: transparent">empty</div>
                        </div>
                    </td>

                    <td v-show="dateIndex==5" @click="linkUrl(props.item.viewItemUrl6)" style="min-height: 80px" :class="['px-1 text-center tableHeaderRight linkName']"  >
                        <div v-if="props.item.viewItemName6!==''"  :class="[props.item.viewItemName6!==''?'tdOutline':'tdNoOutline',isLink(props.item.viewItemUrl6)?'tdClick':'noLink']">
                            <div v-show="props.item.viewItemName6!==''" class="clinicName iconSmallFont">{{props.item.clinicName}}</div>
                            <div class="iconSmallFont">{{props.item.viewItemExtName6}}</div>
                            <div class="divName">
                                <!--額滿 #--><img v-show="props.item.viewItemMarkFlag6!==''&&props.item.viewItemMarkFlag6.indexOf('#')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/full.png">
                                <!--不允許網路掛號 *--><img v-show="props.item.viewItemMarkFlag6!==''&&props.item.viewItemMarkFlag6.indexOf('*')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/noReg.png">
                                <!--代診醫師 R --><img v-show="props.item.viewItemMarkFlag6!==''&&props.item.viewItemMarkFlag6.indexOf('R')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/replaceDoc.png">
                                <!--性平標記 六色旗 S --><img v-show="props.item.viewItemMarkFlag6!==''&&props.item.viewItemMarkFlag6.indexOf('S')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/sixColorFlag.png">
                               <span :class="[props.item.viewItemMarkFlag6!==''?'iconSmallFont':'']">{{props.item.viewItemName6}}</span>
                            </div>
                        </div>

                        <div v-else  :class="[props.item.viewItemMarkFlag6!==''?'iconSmallFont':'','tdNoOutline']">
                            <div class="iconSmallFont" style="color: transparent">empty</div>
                            <div class="iconSmallFont" style="color: transparent">empty</div>
                            <div style="color: transparent">empty</div>
                        </div>
                    </td>
                    <td v-show="dateIndex==6" @click="linkUrl(props.item.viewItemUrl7)" style="min-height: 80px" :class="['px-1 text-center tableHeaderRight linkName']"  >
                        <div v-if="props.item.viewItemName7!==''"  :class="[props.item.viewItemName7!==''?'tdOutline':'tdNoOutline',isLink(props.item.viewItemUrl7)?'tdClick':'noLink']">
                            <div v-show="props.item.viewItemName7!==''" class="clinicName iconSmallFont">{{props.item.clinicName}}</div>
                            <div class="iconSmallFont">{{props.item.viewItemExtName7}}</div>
                            <div class="divName">
                                <!--額滿 #--><img v-show="props.item.viewItemMarkFlag7!==''&&props.item.viewItemMarkFlag7.indexOf('#')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/full.png">
                                <!--不允許網路掛號 *--><img v-show="props.item.viewItemMarkFlag7!==''&&props.item.viewItemMarkFlag7.indexOf('*')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/noReg.png">
                                <!--代診醫師 R --><img v-show="props.item.viewItemMarkFlag7!==''&&props.item.viewItemMarkFlag7.indexOf('R')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/replaceDoc.png">
                                <!--性平標記 六色旗 S --><img v-show="props.item.viewItemMarkFlag7!==''&&props.item.viewItemMarkFlag7.indexOf('S')>-1" style="width: 15px" src="../../../assets/images/regMarkFlag/sixColorFlag.png">
                                <span :class="[props.item.viewItemMarkFlag7!==''?'iconSmallFont':'']">{{props.item.viewItemName7}}</span>
                            </div>
                        </div>

                        <div v-else  :class="[props.item.viewItemMarkFlag7!==''?'iconSmallFont':'','tdNoOutline']" disabled>
                            <div class="iconSmallFont" style="color: transparent">empty</div>
                            <div class="iconSmallFont" style="color: transparent">empty</div>
                            <div style="color: transparent">empty</div>
                        </div>

                    </td>
                </tr>
            </template>
            <template slot="no-data">

                <v-alert :value='loading' type="warning" icon="mdi-alert-circle">
                    查詢中...
                </v-alert>
                <v-alert :value='!loading' color="info" icon="mdi-information">
                    表格中沒有內容
                </v-alert>

            </template>

        </v-data-table>
    </v-flex>
</template>

<script>
    export default {
        name: "ClinicTableNoHead",
        data() {
            return {
                loadingText: '查詢中...',
            }
        },
        props:{
            clinicHeaders:{
              type:Array,
            },
            clinicData:{
                type:Array,
            },
            loading:{
                type:Boolean,
                default:false
            },
            tableTitle:{
                type:String,
                default:'',
            },
            goWhere:{
                type:String,
                default:'',
            },
            dateIndex:{
                type:Number,
                default:0
            }
        },
        created(){


        },
        mounted(){
            // console.log(document.querySelector('.clickTd').clientHeight)
        },
        methods:{
            //特殊標記以icon顯示 size 15*15
            /**
             * 代號       顯示內容
             ====       ========
             #            額滿
             *           不允許網路掛號

             * **/
            setMarkIcon(mark){
                let imgSrc = '';
                switch (mark){
                    case '#'://額滿
                        imgSrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAArFJREFUeNq0VU1ME0EUfltWQNS2UGLiAayeMS1nTMSjmihHNSb2aMKlnkz0YDlo4sl6MMFbDyZcGw9eLYmcWULvVkg0mKDdKijlZ5xvum+Y2e4SCPqS6Uxnd9+8973ve+MIIQj21cmU5FSUI0XHM1+O8jmxDn/k4ADp3JPrHP1bW5KH5BNB5IdyfiJ/qWsvkU6pEWE5+E4EsGhLV17TYPVtl7Nk+TkNL9a69odq79SIsaIbxrwnO0K9Vyao/9Y12nj1hkTTV/v9U9fVfKr4gHYbK/tZ5cbUfKb0SM3b3jL9qb7nxyn6QkPCHGvZvNiqfRSwtrcsjmr4xvTn4Ccqt97JCWrXFtTMECHa1sMnKkq2zIcOPOtXb6p5x6vTXpA1zI0DD87NmaE6WbhDiWoHVdeoB78XNjccNYr4uzJnRQEDrqgNsmDc2XY/r8Yyz4II7EFxhd+iZmHaLJamqZNOarjiYInN4FfphXQyRj3nRyRrbqgDAMmAHNZH2VGLOTqTxir9lD5MlkUWGZFyIaUajyRfkGCjPLsvxKiXTJYwxmuDF+nbhXG0FWrPL3D/0nvQDCvbUvphokLKpyUcZz8tatqy+LAHqERMDSIPgFqHvXlrD8xCJn2Tl41M6yob89ADi9xpFaOUfPlMr3WxJHtQfHMPUYO6YF2cDroyYMZsL9UtNgwU7mpYnADnvqA/OamkXndZuBftNFZUT/lRmFb/YbznFx8LyXfdd7DerMypwSZpavmzIALnAQNS3jJEBhGBehhccAjt+9Q9JTL9/f3bB0PEBYTATGWK4AB+xowB7ngPkDnRl44qss93ApxAA2CMdi6z2Wu2QjqpWw4z8sJB5rBN41v4hpJxZT6NoxlYg4jDvQaC4j2sXdliInrSzP+/9IN+k8dpAVzHNfiYCXzSXwEGAHC4xRcz0rBdAAAAAElFTkSuQmCC';
                        break;
                    case '*'://禁止掛號
                        imgSrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAgdJREFUeNq8Vj1PAkEQnUNUCApEbSxUfoCG6ymkVaNSaqKRTo0mUmlhARSa2GFhoh1WWKqJ2lJoLQR+gB+JxgSUwyCfsu6sxwW8WwIiTrLZ2dzw3szs7lsEQgigPQv9Pjp56LBAaybRERgkScQDAQkoeIT6dvhbi1ISUSdn/tfgaHbEFp6gL8VrS4dtGEyeFTC4JqFjZKjmW+7sCnKnF5ANhuq2CwmI1pde3xb0eDeVdTEaB5KSmN8pjoFgMTP/8/4R3lyLUIzEtCmQ4Of4CIZIxd59e+TFJqpiXl0LpBCJsZhySmJrLSxVBebALpg2loFIaUg6Z/iZyZUM3IaZz4vXVS+6nI6mwPvD50qbsGXmwI4qrobA5FllM21LQ+AImj0+gYQ4zki6xh0sSU0CndUChtkJln0mcNgweMq9BnQPlN8YXFPaBHpxlM358E1T4MqxPb2UY0b5LUIrcVpTD5ztw92DEleX4Dfg1VaW7wqXQP8jg0bB8dZXV6IiKEXibO6mpwA3vNnMUU7YjZdxVARYGuoLghnd802BY0KoWd+bfcGXioRzWrn6ONBQNrQkQEta8uFr1beaPSjQI5rZP2JZ48CK6mWOZg0egHFpjt2ftGe7fWKH1Tckdjy5RimonBCUhGoZl9zrXGn5lwcHn0wvtMf87X/00UMH2eS/HK0aYvhlTPgSYACrua5sWl5+rwAAAABJRU5ErkJggg==';
                        break;
                    default:
                }
                return imgSrc;
            },
            addLink(name,url,divName,clinicName){ //醫師連結 URL
                // let link = '<a href='+"'"+url+"'"+'>'+name+'</a>';

                let link ='<div class="tdOutline">' +clinicName+"<br/>"+divName+"<br/>"+name+'</div>';
                return url==''?name:link;
            },
            splitURL(name,url){
                    return  decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(this.$store.state.AppSetting.backSrvUrl+"?"+url)||[""])[1].replace(/\+/g,'%20'))||null;

            },
            isLink(url){
                if(url!==""){
                    let today = this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(),'date');
                    let daySplit = today.split("-")
                    let nowDay = (daySplit[0]-1911)+""+daySplit[1]+""+daySplit[2];//今天民國年
                    let viewDate =   this.splitURL("viewDate",url);
                    if(viewDate<nowDay){
                        return false
                    }else {
                        return true;
                    }
                }else {
                    return true;
                }
            },
            linkUrl(url){ //連結掛號 畫面
                // viewItemUrl1: "viewDate=1091012&apn=1&doctorNo=D03&doctorName=李O明&zone=A&clinicNo=3&clinicName=三診"
                if(url!==""&&this.isLink(url)){
                    const urlParams = new URLSearchParams(this.$store.state.AppSetting.backSrvUrl+'?'+url);
                    let divName = urlParams.get('divName');
                    this.$router.push({name: 'RegTan', query: {viewDate:this.splitURL("viewDate",url),apn: this.splitURL("apn",url),
                            doctorNo:this.splitURL("doctorNo",url),zone:this.splitURL("zone",url),clinicNo:this.splitURL("clinicNo",url),
                            doctorName:this.splitURL("doctorName",url),clinicName:this.splitURL("clinicName",url),
                            divNo:this.splitURL("divNo",url),divName:divName}});
                    // switch (this.goWhere){
                    //     case 'tan': //四季台安
                    //         this.$router.replace({path: '/regtan', query: {viewDate:this.splitURL("viewDate",url),apn: this.splitURL("apn",url),
                    //                 doctorNo:this.splitURL("doctorNo",url),zone:this.splitURL("zone",url),clinicNo:this.splitURL("clinicNo",url),
                    //                 doctorName:this.splitURL("doctorName",url),clinicName:this.splitURL("clinicName",url),
                    //                 divNo:this.splitURL("divNo",url),divName:this.splitURL("divName",url)}});
                    //         break;
                    //     case 'daan': //大安
                    //         this.$router.replace({path: '/regdaan', query: {viewDate:this.splitURL("viewDate",url),apn: this.splitURL("apn",url),
                    //                 doctorNo:this.splitURL("doctorNo",url),zone:this.splitURL("zone",url),clinicNo:this.splitURL("clinicNo",url),
                    //                 doctorName:this.splitURL("doctorName",url),clinicName:this.splitURL("clinicName",url),
                    //                 divNo:this.splitURL("divNo",url),divName:this.splitURL("divName",url)}});
                    //         break;
                    //     case 'ksph'://凱旋
                    //         this.$router.replace({path: '/regksph', query: {viewDate:this.splitURL("viewDate",url),apn: this.splitURL("apn",url),
                    //                 doctorNo:this.splitURL("doctorNo",url),zone:this.splitURL("zone",url),clinicNo:this.splitURL("clinicNo",url),
                    //                 doctorName:this.splitURL("doctorName",url),clinicName:this.splitURL("clinicName",url),
                    //                 divNo:this.splitURL("divNo",url),divName:this.splitURL("divName",url)}});
                    //         break;
                    //     default:
                    //         this.$router.replace({path: '/regtan', query: {viewDate:this.splitURL("viewDate",url),apn: this.splitURL("apn",url),
                    //                 doctorNo:this.splitURL("doctorNo",url),zone:this.splitURL("zone",url),clinicNo:this.splitURL("clinicNo",url),
                    //                 doctorName:this.splitURL("doctorName",url),clinicName:this.splitURL("clinicName",url),
                    //                 divNo:this.splitURL("divNo",url),divName:this.splitURL("divName",url)}});
                    // }
                }else {
                    return;
                }


            }
        }
    }
</script>

<style scoped>

    .tdClick{
        cursor: pointer!important;
    }

    .noLink{
        cursor: default!important;
    }

    .tdOutline{
        margin: 3px 3px;
        border-radius: 15px;
        height: auto;
        /*padding: 5px;*/
        /*cursor: pointer;*/
        border: 0.1px solid rgba(0, 0, 0, 0.12);
        background: white;
    }

    .tdNoOutline{
        margin: 3px 3px;
        border-radius: 15px;
        height: auto;
        /*padding: 5px;*/
        border: 0.1px solid rgba(0, 0, 0, 0);
        background: transparent;
        color: transparent;
    }

    .divName{
        font-weight: bold;
        color: blue;
    }

    .clinicName{
        color: red;
    }

    .iconSmallFont{
        font-size: 16px!important;
    }

    .noLink{
        cursor: none;
    }




</style>